<template>
  <component :is="dynamicComponent"></component>
</template>

<script>
import Archive from '@/components/Archive.vue'
import Abc from '@/components/Abc.vue'
import Search from '@/components/Search.vue'
import Videos from '@/components/Videos.vue'

export default {
  data () {
    return {
      selected: false
    }
  },

  components: {
    Archive,
    Abc,
    Search,
    Videos
  },

  computed: {
    dynamicComponent () {
      let comp
      if (this.$route.params.filter === 'videos') {
        comp = 'Videos'
      } else if (this.$route.params.filter === 'rechercher') {
        comp = 'Search'
      } else if (this.$route.params.filter === 'abc') {
        comp = 'Abc'
      } else {
        comp = 'Archive'
      }
      return comp
    }
  },

  mounted () {
    let backState = {
      page: this.$route.name,
      slug: this.$route.params.filter
    }

    this.$store.commit('editState', { state: 'backState', data: backState })
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('editState', { state: 'cardOpen', data: false })
    this.$store.commit('editState', { state: 'cardActive', data: false })
    next()
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';
#archiveOuter {
  position: relative;
  transition: opacity $ease ease;
  z-index: 3;
}

.cardActive .laureatGroup:not(.active) {
  visibility: hidden;
}

#archive {
  padding-top: 3rem;
  position: relative;
  overflow: hidden;
  padding-bottom: 20rem;
  min-height: calc(var(--vh, 1vh) * 100 - 5rem);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cardActive #archive,
.abLogo .cardActive #archive {
  padding: 0;
  height: calc(var(--vh, 1vh) * 100);
  min-height: auto;
}

.selectedOpen {
  #archive {
    position: absolute;
    height: 100%;
    overflow: hidden;
    z-index: -1;
  }
}

@media screen and (max-width: $breakPoint1) {
  .abLogo {
    #archive {
      padding-top: calc(#{$moblogo} + 4rem);
    }

    #archiveOuter {
      padding-top: 0;
    }
  }
}
</style>
